import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from '@shared/pagination';
import { Job } from '@shared';
import { Store } from '@ngrx/store';
import { getAggregatedJobDataForJobId } from '@collections/aggregations';

@Component({
  selector: 'mojo-pipeline-jobs-list',
  templateUrl: './pipeline-jobs-list.component.html',
})
export class PipelineJobsListComponent {
  @Input() pipelineAllActiveJobs: Pagination<Job>;
  @Output() reloadList = new EventEmitter();

  constructor(private store: Store<{}>) {}

  getAggregatedJobData(jobId) {
    return this.store.select(getAggregatedJobDataForJobId, { jobId });
  }
  pageChange(offset: number): void {
    this.reloadList.emit(offset);
  }
}
